let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("l1hGE")).then(() => parcelRequire('4eZAr'));